
    import {computed, defineComponent, onMounted, reactive, toRefs, ref} from 'vue';
    import ApiUser from "@/request/apis/api_user";
    import PageUtil from "@/utils/page_util";
    import {message} from "ant-design-vue/es";
    interface IState {
        searches: any,
        total: any,
        list: any,
        treeData: any,
        platform_cate: any,
        title: any,
        visible: any,
        orderData: any,
        loading:any,
        detailData:any,
        examData:any,
        visible2:any
    }


    export default defineComponent({
        name: 'salaryRange',
        components: {},
        setup() {
            let state: IState = reactive({
                searches: {
                    keywords: '',
                    type:1,
                    page: PageUtil.pageNo,
                    limit: PageUtil.pageSize
                },
                total: 0,
                platform_cate: [],
                list: [],
                treeData: [],
                title: "",
                visible: false,
                orderData: '',
                loading:false,
                detailData:'',
                examData:'',
                visible2:false
            })
            const columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '店铺信息',
                    dataIndex: 'shop',
                    key: 'shop',
                },
                {
                    title: '联系人',
                    dataIndex: 'concat',
                    key: 'concat',
                },
                {
                    title: '企业资质',
                    dataIndex: 'company',
                    key: 'company',
                },
                {
                    title: '资质文件',
                    dataIndex: 'file',
                    key: 'file',
                },
                {
                    title: '审核状态',
                    key: 'status',
                    dataIndex: 'status',
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150
                },
            ];

            const getList = async () => {
                state.loading = true
                const params = {...state.searches}
                const res = await ApiUser.ApplyLists(params)
                if (res.error_code == 0) {
                    const data: any = res.data
                    state.total = data.count
                    state.list = data.lists
                    state.loading = false
                }
            }

            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page,
                pageSize: state.searches.limit,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否启用pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));
            const handleTableChange = (pages: any) => {
                state.searches.limit = pages.pageSize
                state.searches.page = pages.current
                getList()
            };


            const OnSearch = () => {
                state.searches.page_size = PageUtil.pageSize
                state.searches.page_no = PageUtil.pageNo
                getList()
            }

            const OnReset = () => {
                state.searches.shop_name = ''
                state.searches.goods_name = ''
                state.searches.platform_cate_id = ''
                state.platform_cate = []
                state.searches.page_no = PageUtil.pageNo
                state.searches.page_size = PageUtil.pageSize
                getList()
            }


            const callback = (key) => {
                state.searches.page = 1
                state.searches.limit = PageUtil.pageSize
                state.searches.type = key
                getList()
            }

            const getDetail = (val) => {
                state.detailData = val
                state.visible = true
            }

            const examine = (val) =>{
                state.examData = val
                state.visible2 = true
            }

            const examSubmit = async () => {
                const data = {id:state.examData.id,audit_status:state.examData.audit_status,audit_explain:state.examData.audit_explain}
                const res = await ApiUser.ApplyAudit(data)
                if (res.error_code == 0) {
                    message.success(res.msg)
                    getList()
                    state.visible2 = false
                }else{
                    message.error(res.msg)
                }
            }
            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                getList,
                examSubmit,
                callback,
                examine,
                getDetail,
                OnReset,
                columns,
                OnSearch,
                pagination,
                handleTableChange
            }
        }
    });
